var $ = require('jquery');
require('./web/jquery.original-edeeshop-photogallery');
var Utils = require('./web/utils');

/**
 * USED EVENTS
 *
 * EDEESHOP_PHOTOGALLERY_ACTIVATE - používáno v detailu produktu po změně varianty (EDEESHOP_PRODUCTDETAIL_VARIANT_CHANGED)
 * EDEESHOP_PRODUCT_LIST_LG_INTERACTIVE_ACTIVATE - používáno v rozeskoku produktů
 *
 */


$(function () {

	$(document).on('EDEESHOP_PHOTOGALLERY_ACTIVATE', function(event) {
	    $('.js_product-photogallery-activate', $(event.target)).originalEdeeshopPhotogallery({
			magnifyEnabled: false,
			model3DEnabled: true
		});

        $(window).on('load', function(){
            var $firstItem = $('.gallery-detail li:first'),
				containerWidth = $firstItem.width(),
                containerHeight = $firstItem.height(),
                motiveWidth = $firstItem.find('> img').width(),
                motiveHeight = $firstItem.find('> img').height(),
				containerSideSpace = (containerWidth - motiveWidth) / 2,
				topOffset = 0,
				topMargin = 0;

            $('.js_profile-list li').each(function () {

            	// Top profile
            	if ($(this).find('a').hasClass('top-profile')) {
                    $('.gallery-detail').addClass('top-profile');
                    topOffset = (containerHeight / 2) - (motiveHeight / 2);
                }

                // Left profile
                if ($(this).find('a').hasClass('left-profile')) {
                    topMargin = $firstItem.find('img').height() / 2;
                }

                $(this).find('a').appendTo($firstItem);
                $firstItem.find('a').css('max-width', motiveWidth+ 'px').css('max-height', motiveHeight+ 'px').css('left', containerSideSpace+'px');
            });

            $firstItem.find('.left-profile').css('margin-top', '-'+topMargin+'px').css('margin-left', '-'+$firstItem.find('.left-profile').width()+'px');
            $firstItem.find('.top-profile').css('top', topOffset+'px').css('margin-top', '-'+$firstItem.find('.top-profile').height()+'px');
            if (Utils.findBootstrapEnvironment() != 'xl' && Utils.findBootstrapEnvironment() != 'lg' && Utils.findBootstrapEnvironment() != 'md' && Utils.findBootstrapEnvironment() != 'sm') {
                $('.gallery-detail').css('min-height',motiveHeight+ 'px');
                $firstItem.css('height',motiveHeight+ 'px');
			}
		});

        $(document).on('click', '.js_product-photogallery-activate .gallery-detail .active > img', function (event) {
            var activeListItem = $('.gallery-detail .active');
        	var activeListItemIndex = $('.gallery-detail li').index( activeListItem );
            $('.js_hs-list li:eq('+activeListItemIndex+') a').click();
		});
	});

	$(document).trigger('EDEESHOP_PHOTOGALLERY_ACTIVATE');

    /**
     * Product list - nastavi stejnou vysku na elementech pro over
     */
    $(document).on('EDEESHOP_PRODUCT_LIST_LG_INTERACTIVE_ACTIVATE UP_AFTER_CONTENT_RENDERED', function(){
        if ( Utils.findBootstrapEnvironment() == 'xl' || Utils.findBootstrapEnvironment() == 'lg' || Utils.findBootstrapEnvironment() == 'md') {
				$('.js_product-list, .product-list-tiles-fulltext, .product-list-slider-related').each(function() {
					var $container = $(this),
						containerLength = $container.children().length;


					if ($container.is(':visible')){

						$container.addClass('preload');

						$container.find('.product-list__item').each(function(i) {
							var tileHeight = $(this).outerHeight();

							$(this).css('height', tileHeight+'px').addClass('height-set');

							$(this).hover(function(){
								var $extendedContent = $(this).find('.extended-content');
								var	tileHeightOver = tileHeight;

								$extendedContent.addClass('get-height');
								$extendedContent.each(function() {
									tileHeightOver += $(this).outerHeight();
								});
								$extendedContent.removeClass('get-height');
								$(this).find('> div').css('height', (tileHeightOver)+'px');
							},	function() {
								$(this).find('> div').css('height', 'inherit');
							});

							if (containerLength - 1 == i) $container.removeClass('preload');
						});
					}
				});
        }

        $('.js_product-list > li, .product-list-tiles-fulltext > li, .product-list-slider-related > li').each(function() {
			var $form = $(this).find('form');
			if ($form.length > 0) {
				/*$(this).find('.btn-show-detail, .product-info-container > a, .product-text-info > a').click(function(e) {
					e.preventDefault();
					$form.submit();
				});*/
				$(this).find('form input[type=radio]').change(function() {
                    $form.submit();
                });
			}
		});
    });
    $(this).trigger('EDEESHOP_PRODUCT_LIST_LG_INTERACTIVE_ACTIVATE');

});

// Ajaxcomplete
$(document).on('ajaxComplete', function(){
    $(this).trigger('EDEESHOP_PRODUCT_LIST_LG_INTERACTIVE_ACTIVATE');
});

// Window resize
$(window).resize(function() {
	$(document).trigger('EDEESHOP_PHOTOGALLERY_ACTIVATE');
    $(document).trigger('EDEESHOP_PRODUCT_LIST_LG_INTERACTIVE_ACTIVATE');
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/eshop.js